import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isDevMode } from "../utils/utilities";
import { useGlobalStore } from "../utils/global";

const timeout = /*minutes*/ 1 * /*secons*/ 60 * /*miliseconds*/ 1000;
export const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: timeout,
});

export const useAPIs = () => {
  const navigate = useNavigate();
  const { showNotification, showLoading, hideLoading } = useGlobalStore();

  useEffect(() => {
    /*REQUEST*/
    const resRequestInterceptor = (config) => {
      if (isDevMode()) {
        console.info("REQUEST CONFIG", config);
      }

      showLoading();
      const userLocalStorage = localStorage.getItem("user");
      const user = userLocalStorage ? JSON.parse(userLocalStorage) : null;

      if (user && user.token) {
        config.headers["Authorization"] = `Bearer ${user.token}`;
      }

      config.headers["Access-Control-Allow-Origin"] = "*";
      config.headers["Content-Type"] = "application/json";

      return config;
    };

    const errResponseInterceptor = (error) => {
      if (isDevMode()) {
        console.info("REQUEST ERROR", error);
      }

      hideLoading();
      return Promise.reject(error);
    };

    /*RESPONSE*/
    const resInterceptor = (response) => {
      if (isDevMode()) {
        console.info("RESPONSE RESULT", response);
      }

      hideLoading();

      if(response.data.successed || response.data.fieldErrors) {
        return response;
      } else if (Array.isArray(response.data.message)) {
        response.data.message.forEach(message => {
          showNotification({
            title: "Error",
            message: message.message,
            isError: true,
          });
        });
        return null;
      } else if (typeof response.data.message === 'string') {
        showNotification({
          title: "Info",
          message: response.data.message,
          isError: false,
        });
        return response;
      } else {
        return response;
      }
    };

    const errInterceptor = (error) => {
      if (isDevMode()) {
        console.error("RESPONSE ERROR", error);
      }

      hideLoading();
      if (error.response && error.response.status === 401) {
        navigate("/login");
      } else {
        
        if (
          error.response &&
          error.response.data &&
          (error.response.data.message || error.response.data.Message)
        ) {
          showNotification({
            title: "Error",
            message: error.response.data.message || error.response.data.Message,
            isError: true,
          });
        } else if (error.data && error.data.Message) {
          showNotification({
            title: "Error",
            message: error.data.Message,
            isError: true,
          });
        } else if (error.message) {
          showNotification({
            title: "Error",
            message: error.message,
            isError: true,
          });
        }
      }

      return Promise.reject(error);
    };

    const APIREQUEST = API.interceptors.request.use(
      resRequestInterceptor,
      errResponseInterceptor
    );

    const APIRESPONSE = API.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );
    
    return () => {
      API.interceptors.request.eject(APIREQUEST);
      API.interceptors.response.eject(APIRESPONSE);
    };
  }, []);
};
